var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"fill-height"},[(_vm.isBoardMember)?_c('board-member-dashboard'):_c('default')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }